import { handleActions } from 'redux-actions'
import {
  SET_SIMULATOR_SOURCE,
  SET_SIMULATOR_INTEGRATION,
  SET_SIMULATOR_API_METHOD,
  SET_SIMULATOR_PAYLOAD,
  SET_SIMULATOR_PAYLOAD_ERROR,
  SET_SIMULATOR_ACTIVE_TAB,

  SIMULATE_EVENT_RESET,
  SIMULATE_EVENT_REQUEST,
  SIMULATE_EVENT_ERROR,
  SIMULATE_EVENT_RESPONSE,

  HIDE_SIMULATOR_MODALS,
  SHOW_SIMULATOR_ACKNOWLEDGE_MODAL,
  SHOW_SIMULATOR_SEND_CONFIRM_MODAL
} from 'actions'

const initialState = {
  source: '',
  writeKey: '',
  integration: '',
  method: 'track',
  payload: '',
  payloadError: '',
  activeTab: '',
  isSendingEvent: false,
  response: null,
  didError: false,
  isShowingAcknowledgeModal: false,
  isShowingSendConfirmModal: false
}

export default handleActions({
  [SET_SIMULATOR_SOURCE] (state, { payload }) {
    const { sourceSlug, writeKey } = payload
    return {
      ...state,
      source: sourceSlug,
      writeKey
    }
  },
  [SET_SIMULATOR_INTEGRATION] (state, { payload }) {
    return {
      ...state,
      integration: payload
    }
  },
  [SET_SIMULATOR_API_METHOD] (state, { payload }) {
    return {
      ...state,
      method: payload
    }
  },
  [SET_SIMULATOR_PAYLOAD] (state, { payload }) {
    return {
      ...state,
      payload
    }
  },
  [SET_SIMULATOR_PAYLOAD_ERROR] (state, { payload }) {
    return {
      ...state,
      payloadError: payload
    }
  },
  [SET_SIMULATOR_ACTIVE_TAB] (state, { payload }) {
    return {
      ...state,
      activeTab: payload
    }
  },
  [SIMULATE_EVENT_RESET] (state) {
    return {
      ...state,
      isSendingEvent: false,
      didError: false,
      response: null
    }
  },
  [SIMULATE_EVENT_REQUEST] (state, { payload }) {
    return {
      ...state,
      isSendingEvent: true
    }
  },
  [SIMULATE_EVENT_ERROR] (state, { payload }) {
    return {
      ...state,
      isSendingEvent: false,
      didError: true
    }
  },
  [SIMULATE_EVENT_RESPONSE] (state, { payload }) {
    return {
      ...state,
      response: payload,
      isSendingEvent: false
    }
  },
  [SHOW_SIMULATOR_ACKNOWLEDGE_MODAL] (state) {
    return {
      ...state,
      isShowingAcknowledgeModal: true
    }
  },
  [SHOW_SIMULATOR_SEND_CONFIRM_MODAL] (state) {
    return {
      ...state,
      isShowingSendConfirmModal: true
    }
  },
  [HIDE_SIMULATOR_MODALS] (state) {
    return {
      ...state,
      isShowingAcknowledgeModal: false,
      isShowingSendConfirmModal: false
    }
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/application/simulator.js